import React from "react";
import Layout from "../components/Layout";
import about1 from "../assets/about1.jpg";
import about2 from "../assets/about2.jpg";
import { useNavigate } from "react-router-dom"; // ADAUGĂ

import { Bolt, Layers, Settings } from "lucide-react";

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="min-h-screen text-gray-900 dark:text-white transition-all duration-300">
        <main className="flex-grow flex flex-col items-center px-4 py-16">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-[#025951] to-green-600 dark:from-green-500 dark:to-emerald-300 bg-clip-text text-transparent uppercase tracking-wide">
              About Us
            </h1>
            <div className="w-24 h-1 bg-green dark:bg-gradient-to-r from-[#025951] to-emerald-400 mx-auto rounded-full"></div>
          </div>

          {/* Main Content Card */}
          <div className="max-w-5xl w-full bg-neutral-200 dark:bg-neutral-800 backdrop-blur-md p-8 md:p-12 rounded-2xl shadow-xl border border-gray-200 dark:border-neutral-500 transition-all duration-300 hover:shadow-2xl hover:border-[#025951] dark:hover:border-emerald-400 mb-16">
            <div className="prose prose-lg max-w-none">
              <div className="grid md:grid-cols-2 gap-8 items-start">
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-600 dark:to-neutral-500 p-6 rounded-xl border-l-4 border-[#025951] dark:border-emerald-400">
                    <p className="text-gray-700 dark:text-gray-200 leading-relaxed">
                      <strong className="text-[#025951] dark:text-emerald-400">
                        FelixDent
                      </strong>{" "}
                      is a London-based digital dental laboratory dedicated to
                      implant and full-arch rehabilitation cases. We focus
                      exclusively on precision-driven restorative solutions for
                      modern private clinics.
                    </p>
                  </div>

                  <div className="bg-gradient-to-br from-green-400 to-green-200 dark:from-emerald-900/30 dark:to-emerald-800/30 p-6 rounded-xl border border-emerald-200 dark:border-emerald-600">
                    <p className="text-gray-700 dark:text-gray-200 leading-relaxed">
                      We operate within a fully digital workflow built around
                      Exocad, compatible with 3Shape, Medit and iTero systems
                      for efficient and accurate case integration.
                    </p>
                  </div>

                  <div className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-600 dark:to-neutral-500 p-6 rounded-xl">
                    <p className="text-gray-700 dark:text-gray-200 leading-relaxed">
                      Our clients value our reliability, attention to detail and
                      direct communication with experienced technicians —
                      ensuring predictable clinical outcomes and seamless case
                      coordination.
                    </p>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-green-400 to-green-200 dark:from-emerald-900/30 dark:to-emerald-800/30 p-6 rounded-xl border border-emerald-200 dark:border-emerald-600">
                    <p className="text-gray-700 dark:text-gray-200 leading-relaxed">
                      We collaborate closely with dental practices across the
                      UK, delivering high-accuracy implant restorations, custom
                      abutments and complex full-arch treatments with consistent
                      technical excellence.
                    </p>
                  </div>

                  <div className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-600 dark:to-neutral-500 p-6 rounded-xl">
                    <p className="text-gray-700 dark:text-gray-200 leading-relaxed">
                      Our expertise covers complex implant restorations,
                      full-arch rehabilitations and custom abutment solutions
                      across all major implant systems.
                    </p>
                  </div>

                  <div className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-600 dark:to-neutral-500 p-6 rounded-xl border-l-4 border-[#025951] dark:border-emerald-400">
                    <p className="text-gray-700 dark:text-gray-200 leading-relaxed">
                      Every case benefits from direct technician involvement —
                      no intermediaries, no unnecessary delays, just clarity,
                      precision and dependable results.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Services Highlights */}
          <div className="max-w-5xl w-full mb-16">
            <h2 className="text-3xl font-bold text-center mb-12 text-gray-900 dark:text-white">
              Implant{" "}
              <span className="text-[#025951] dark:text-emerald-400">
                & Digital Capabilities
              </span>
            </h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white dark:bg-neutral-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 dark:border-neutral-500 hover:border-[#025951] dark:hover:border-emerald-400 group">
                <div className="w-12 h-12 bg-[#025951] dark:bg-gradient-to-br dark:from-[#025951] dark:to-emerald-400 rounded-lg mb-4 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <Bolt className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
                  Implant Restorations
                </h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Screw-retained and cement-retained implant restorations with
                  precise passive fit and predictable aesthetics.
                </p>
              </div>

              <div className="bg-white dark:bg-neutral-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 dark:border-neutral-500 hover:border-[#025951] dark:hover:border-emerald-400 group">
                <div className="w-12 h-12 bg-[#025951] dark:bg-gradient-to-br dark:from-[#025951] dark:to-emerald-400 rounded-lg mb-4 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <Layers className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
                  Full-Arch Solutions
                </h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Full-arch rehabilitations including All-on-X cases, designed
                  digitally for stability, strength and long-term success.
                </p>
              </div>

              <div className="bg-white dark:bg-neutral-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 dark:border-neutral-500 hover:border-[#025951] dark:hover:border-emerald-400 group">
                <div className="w-12 h-12 bg-[#025951] dark:bg-gradient-to-br dark:from-[#025951] dark:to-emerald-400 rounded-lg mb-4 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <Settings className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
                  Custom Abutments & CAD/CAM
                </h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Custom abutments across all major implant systems, engineered
                  through advanced CAD/CAM workflows.
                </p>
              </div>
            </div>
          </div>

          {/* Image Carousel */}
          <div className="max-w-4xl w-full">
            <h2 className="text-3xl font-bold text-center mb-8 text-gray-900 dark:text-white">
              Our{" "}
              <span className="text-[#025951] dark:text-emerald-400">Work</span>
            </h2>
            <div className="rounded-2xl shadow-2xl relative aspect-video overflow-hidden border-4 border-white dark:border-neutral-600 transition-all duration-300 hover:shadow-[0_0_40px_rgba(52,211,153,0.3)] dark:hover:shadow-[0_0_40px_rgba(16,185,129,0.3)]">
              <img
                src={about1}
                alt="FelixDent Work 1"
                className="absolute inset-0 w-full h-full object-contain animate-fade-in-out bg-white dark:bg-neutral-800"
                style={{ animationDelay: "0s" }}
              />
              <img
                src={about2}
                alt="FelixDent Work 2"
                className="absolute inset-0 w-full h-full object-contain animate-fade-in-out bg-white dark:bg-neutral-800"
                style={{ animationDelay: "5s" }}
              />

              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-green-300 to-transparent"></div>

              {/* Caption */}
              <div className="absolute bottom-4 left-4 text-white">
                <p className="text-lg font-semibold drop-shadow-lg">
                  Professional Dental Solutions
                </p>
                <p className="text-sm opacity-90 drop-shadow-lg">
                  Quality craftsmanship in every project
                </p>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="max-w-4xl w-full mt-16 text-center">
            <div className="bg-[#025951] dark:bg-gradient-to-r dark:from-emerald-500 dark:to-emerald-400 text-white p-8 rounded-2xl shadow-2xl">
              <h3 className="text-2xl md:text-3xl font-bold mb-4">
                Looking for a Reliable Implant Lab?
              </h3>

              <p className="text-lg mb-6 opacity-90">
                Send us your first implant or full-arch case and experience our
                digital workflow and precision.
              </p>

              <button
                onClick={() => navigate("/contact-us")}
                className="bg-white text-[#025951] dark:bg-neutral-800 dark:text-emerald-400 px-8 py-3 rounded-full font-semibold hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
              >
                Request a Test Case
              </button>
            </div>
          </div>
        </main>
      </div>
    </Layout>
  );
};

export default AboutUs;
